import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { dateFormat } from "../../common/Contants";
import { IEnterDate } from "./SelectModelsInterfaces";

dayjs.extend(customParseFormat);

export default function EnterDate({
  onChange,
}: IEnterDate) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [endDateError, setEndDateError] = useState<string | null>(null);
  const [showStartDateError, setShowStartDateError] = useState(false);
  const [showEndDateError, setShowEndDateError] = useState(false);
  const validateDateFormat = (date: string) =>
    dayjs(date, dateFormat, true).isValid();
  const parseDate = (date: string) => dayjs(date, dateFormat).toDate();

  useEffect(() => {
    const isStartValid = validateDateFormat(startDate);
    const isEndValid = validateDateFormat(endDate);
    const start = isStartValid ? parseDate(startDate) : null;
    const end = isEndValid ? parseDate(endDate) : null;

    let startError = null;
    let endError = null;
    let isEndDateCoherent = true;

    if (startDate && !isStartValid) {
      startError = `Enter a valid Start Date (${dateFormat})`;
    }

    if (endDate) {
      if (!isEndValid) {
        endError = `Enter a valid End Date (${dateFormat})`;
        isEndDateCoherent = false;
      } else if (start && end && start >= end) {
        endError = "End Date should be greater than Start Date";
        isEndDateCoherent = false;
      }
    }

    setStartDateError(startError);
    setEndDateError(endError);

    if (startDate.length >= dateFormat.length) {
      setShowStartDateError(true);
    }

    if (endDate.length >= dateFormat.length) {
      setShowEndDateError(true);
    }
    onChange(startDate, endDate, isStartValid, isEndDateCoherent);
  }, [startDate, endDate]);

  return (
    <>
      <Row className="padding-top">
        <Col xs={2}>
          <label>Start Date</label>
        </Col>
        <Col xs={3}>
          <input
            type="text"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              setShowStartDateError(false);
            }}
            placeholder={dateFormat}
            className="form-control"
          />
          {startDateError && showStartDateError && (
            <label className="errorMessage">{startDateError}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          <label>End Date</label>
        </Col>
        <Col xs={3}>
          <input
            type="text"
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              setShowEndDateError(false);
            }}
            placeholder={dateFormat}
            className="form-control"
          />
          {endDateError && showEndDateError && (
            <label className="errorMessage">{endDateError}</label>
          )}
        </Col>
      </Row>
    </>
  );
}
